var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { useColorModeValue } from "@chakra-ui/system";
import { Box } from "../Box";
import { CompassLoader } from "../Loader";
import { H1 } from "../Heading";
import { CompassColor } from "../../core";
import { useBreakpointValue } from "../../hooks";
import { useWebAssets } from "../../hooks/useWebAssets";
const defaultStyles = {
    display: "flex",
    w: "100vw",
    h: "100vh",
    position: "relative",
    flexDir: "column",
    alignItems: "center",
    justifyContent: "center",
    color: CompassColor.offWhite,
    backgroundPosition: "center",
    backgroundSize: "cover",
    fontFamily: "Untitled Sans",
    fontWeight: 500,
};
/**
 * Default loader view for web apps
 * @param text - text beneath the loader
 * @param quote - quote on the bottom of the view
 */
function LoaderView(_a) {
    var { className, text = "Loading...", quote = { text: "Mother Father Cheers", author: "Saeju Jeong" } } = _a, styles = __rest(_a, ["className", "text", "quote"]);
    const { createAssetUrl } = useWebAssets();
    const loaderSize = useBreakpointValue({
        base: "lg",
        sm: "lg",
        md: "xl",
    });
    const bgColor = useColorModeValue("#00000020", "#FFFFFF20");
    const compassColor = useColorModeValue(CompassColor.offWhite, CompassColor.grey4);
    const defaultStylesWithBackground = useMemo(() => {
        return Object.assign(Object.assign({}, defaultStyles), { background: `url('${createAssetUrl("image", "auth-background.jpg")}')` });
    }, [createAssetUrl]);
    return (React.createElement(Box, Object.assign({ className: className }, defaultStylesWithBackground, styles),
        React.createElement(Box, { flex: 1, paddingTop: 10, width: "100%", paddingBottom: 5, paddingX: 10, background: bgColor, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" },
            React.createElement(CompassLoader, { size: loaderSize, mb: 10, color: compassColor }),
            React.createElement(H1, { fontFamily: "Untitled Sans", fontWeight: 500, color: compassColor }, text)),
        quote && (React.createElement(Box, { zIndex: 1, fontWeight: 300, position: "absolute", bottom: "0", padding: 2, textAlign: "center", width: "100%", background: bgColor, color: compassColor, fontFamily: "Brown LL" },
            "\"",
            quote.text,
            "\" - ",
            quote.author))));
}
LoaderView.displayName = "LoaderView";
export default LoaderView;
//# sourceMappingURL=LoaderView.js.map